export enum UrlProtocol {
	Https,
	Http,
}
